import React from 'react';
import 'themes/scss/common.scss';

// Error Component
export const errorMessage = (error) => {
  return <div className='text-danger pt-2 form_error'>{error}</div>;
};

const ErrorMessage = ({ error, messages }) => {
  if (!error) return null;
  return (
    <p className='text-danger mb-3 form_error'>
      {messages[error.type] ? messages[error.type] : ''}
    </p>
  );
};

export default ErrorMessage;
